import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { RectangleLoader } from "./RectangleLoader";

interface ActionBarTitleLoaderProps {
    customStyle?: any;
}

export const ActionBarTitleLoader = ({
    customStyle
}: ActionBarTitleLoaderProps) => {
    const { gray200 } = colors;

    return (
        <div
            css={[
                css({
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 0",

                    "span + span": {
                        marginLeft: "16px"
                    },

                    "@media (max-width: 599px)": {
                        padding: "0"
                    }
                }),
                customStyle
            ]}
        >
            <RectangleLoader
                width={216}
                borderRadius={"46px"}
                backgroundColor={gray200}
                height={24}
            />

            <RectangleLoader
                width={38}
                borderRadius={"46px"}
                backgroundColor={gray200}
                height={24}
            />
        </div>
    );
};
